import React from 'react'

import './style.css'

const SetupProgress = ({ percentage }) => (
  <div className="setup-progress">
    <span style={{ width: `${percentage}%` }} />
  </div>
)

export default SetupProgress
